import React__default from 'react';
import { EmbeddedTableCore } from '../shared/components/EmbeddedTable.mjs';
import { TableActions } from './TableActions.mjs';
import { Typography } from './Typography.mjs';

const TypographyCustom = (props)=>/*#__PURE__*/ React__default.createElement(Typography, {
        ...props,
        variant: "caption",
        color: "secondary"
    });
const tableHeaderSx = (theme)=>({
        borderBottomColor: theme.styleConfig.colors.subtle
    });
const EmbeddedTable = (props)=>{
    return /*#__PURE__*/ React__default.createElement(EmbeddedTableCore, {
        ...props,
        TableActionsComponent: TableActions,
        TypographyComponent: TypographyCustom,
        tableHeaderSx: tableHeaderSx
    });
};

export { EmbeddedTable };
//# sourceMappingURL=EmbeddedTable.mjs.map
